import { KnownIssueView } from "./KnownIssueView";

export * from "./KnownIssueView";

export default KnownIssueView;
